// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2v8ig","header":"Messages_header__2_l06"};